module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.77e50ab.ttf";